import { type FieldDetailedValue } from '@eflight/shared';

export type FieldDetailedValueGroup<CT extends string = string> = {
    label: string;
    values: Array<FieldDetailedValue<CT>>;
};

export type { FieldDetailedValue };

export function generateLabels<T extends string>(labelMap: Map<T, string>): Array<FieldDetailedValue<T>> {
    return [...labelMap.entries()].map(([value, label]) => ({ value, label }));
}

export function generateFieldDetailedValueMap(values: FieldDetailedValue[]): Map<string, FieldDetailedValue> {
    return new Map(values.map((value) => [value.value, value]));
}

export function mapStringsToFieldDetailedValues(
    strings: string[],
    options: FieldDetailedValue[]
): FieldDetailedValue[] {
    return strings.map((value) => options.find((o) => o.value === value)).filter(Boolean) as FieldDetailedValue[];
}
